<!-- Customer association mode banner -->
<template>
  <div
    class="customer-association-banner d-flex align-items-center justify-content-between px-3 py-2"
    ref="bannerRef"
  >
    <div class="customer-association-banner__text">
      <span class="customer-association-banner__mode">{{ $t('customerAssociationMode') }}</span>
      <span class="customer-association-banner__name">{{
        $t('associationBanner', { name: customerName })
      }}</span>
    </div>
    <button class="btn customer-association-banner__btn py-1 px-2 px-md-3" @click="unassociate">
      {{ $t('unassociate') }}
    </button>
  </div>
  <div class="customer-association-banner__outline" aria-hidden="true"></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';
import ToastService from '@/modules/toasts/services/ToastService';

export default {
  name: 'WCEmployeeAssociationBanner',
  computed: {
    ...mapGetters({
      user: 'user/getUser',
    }),
    customerName() {
      return this.user && this.user.dispShort ? this.user.dispShort : this.user.disp;
    },
  },
  mounted() {
    this.$nextTick(this.updateBannerHeight);
  },
  unmounted() {
    document.documentElement.style.setProperty('--assoc-banner-height', '0px');
    const mobileHeader = document.getElementById('mobile-header-v2');
    if (mobileHeader) {
      const totalOffset = Math.ceil(mobileHeader.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--mobile-header-height', `${totalOffset}px`);
    }
  },
  methods: {
    ...mapActions({
      reloadCart: 'cart/reload',
    }),
    updateBannerHeight() {
      const height = this.$refs.bannerRef?.getBoundingClientRect().height ?? 0;
      document.documentElement.style.setProperty('--assoc-banner-height', `${height}px`);
      const mobileHeader = document.getElementById('mobile-header-v2');
      if (mobileHeader) {
        const totalOffset = Math.ceil(mobileHeader.getBoundingClientRect().bottom);
        document.documentElement.style.setProperty('--mobile-header-height', `${totalOffset}px`);
      }
    },
    async unassociate() {
      try {
        await axios.post('/api/employee/cs', { id: null });
        this.reloadCart();
        this.$router.push({
          name: 'EmployeeCustomerSelect',
        });
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'success',
            title: this.$t('customerAssociation'),
            message: this.$t('unassociateSuccess'),
          },
          timeout: 7000,
        });
      } catch (error) {
        console.error(error);
        ToastService.open(WCSimpleToast, {
          props: {
            variant: 'danger',
            title: this.$t('error'),
            message: error.message,
          },
          timeout: 7000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.customer-association-banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: var(--danger, $danger);
  z-index: map-get($zindex, 'header') + 1;

  &__text {
    display: flex;
    flex-direction: column;
    min-width: 0;

    @include media-breakpoint-up(lg) {
      flex-direction: row;
      align-items: center;
      gap: 0.94rem;
    }
  }

  &__mode {
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: var(--white, $white);
  }

  &__name {
    font-size: 1rem;
    font-weight: 700;
    color: var(--white, $white);

    @include media-breakpoint-up(lg) {
      font-size: 1rem;
    }
  }

  &__btn {
    flex-shrink: 0;
    background-color: var(--white, $white);
    color: var(--danger, $danger);
    font-weight: 600;
    border-radius: 1.3125rem;

    &:hover,
    &:focus {
      background-color: var(--white, $white);
      color: var(--danger, $danger);
      opacity: 0.85;
    }
  }

  &__outline {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 0.1875rem solid var(--danger, $danger);
    pointer-events: none;
    z-index: 10001 !important;
  }
}
</style>
